import styled from '@emotion/styled'

import { Colors } from '@/components/Landing/shared'

export const MainMenu = styled.div<{ active: boolean }>(({ active }) => {
  return {
    fontWeight: 700,
    a: {
      color: active ? Colors.PRIMARY_DEFAULT : Colors.JAGUAR_BLACK,
    },

    marginBottom: '12px',
  }
})

export const SubMenu = styled.li`
  font-size: 14px;

  &:not(:last-of-type) {
    margin-bottom: 12px;
  }
`

export const linkStyle = {
  cursor: 'pointer',
  transition: 'color 0.2s, font-weight 0.2s',
  position: 'relative',
  color: Colors.JAGUAR_BLACK,

  _before: {
    display: 'block',
    position: 'absolute',
    width: '6px',
    height: '32px',
    borderRadius: '4px',
    backgroundColor: Colors.PRIMARY_DEFAULT,
    left: '-22px',
    top: '50%',
    transform: 'translateY(-50%)',
  },

  '&.active': {
    color: Colors.PRIMARY_DEFAULT,
    fontWeight: 500,

    _before: {
      content: '""',
    },
  },

  _hover: { color: Colors.PRIMARY_LIGHT },
}
